import { css } from '@emotion/core';
import { FontNormal } from '@css/fonts';
import '@css/reset';
import {
  red, black, placeholderGray
} from '@css/constants';

/*
 * Common Styles
 * -----------------------------------------------
 */
export const animatedStyle = css`
  -o-transition: .5s;
  -ms-transition: .5s;
  -moz-transition: .5s;
  -webkit-transition: .5s;
  transition: .5s;
`;

export const backgroundImageStyle = css`
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

/*
 * Form Input Styles
 * -----------------------------------------------
 */
export const fontSize = (pxValue: number) => `
 font-size: ${pxValue}px;
 font-size: ${pxValue / 16}rem;
`;

export const formInputStyle = css`
  ${FontNormal(400)}
  ${fontSize(15)}

  color: ${black};
`;

export const formEntryStyle = css`
  height: 56px;
  padding: 12px 10px;
  background-color: transparent;
  border: 1px solid #B1B7BA;
  border-radius: 2px;
  box-sizing: border-box;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

export const formInputErrorStyle = css`
  border: 3px solid ${red};
`;

export const formInputPlaceholderStyle = css`
  ${FontNormal(500)}

  color: ${placeholderGray};
`;
